import { useMemo } from 'react';
import type { UserRoles } from '@dynamika-shared/types/auth';
import { QueryItem, QueryTicketDto } from '@restore/queries/queries.types';
import {
  getQueryCapabilities,
  QueryCapabilities,
  QueryCapability,
} from '@components/Queries/flow/queryFlow';

export const useQueryCapabilities = (
  query: QueryTicketDto | QueryItem,
  role: UserRoles
): QueryCapabilities => {
  return useMemo(() => {
    if (!query?.status) {
      return {
        canSendMessage: false,
        availableEvents: [] as QueryCapability[],
        canDo: () => false,
        getEventMeta: () => undefined,
      };
    }
    return getQueryCapabilities(query.status, role);
  }, [query, role]);
};
